import {
  AuthModalContent,
  OnboardingModalContent,
} from '@sunrise-ui/composites';
import {
  Header,
  HeaderTitle,
  Loader,
  LogoIcon,
  Modal,
  useAuthStore,
  useDynamicStyles,
} from '@sunrise-ui/primitives';
import React, { useEffect } from 'react';
import { StyleSheet, View } from 'react-native';

/**
 * Single parent modal that handles the entire auth + onboarding flow.
 */
export function CommunityAuthFlowModal() {
  const {
    modalFlow,
    isAuthenticated,
    hasCheckedAuth,
    hasCheckedOnboarding,
    isOnboarded,
    completeModalFlow,
    dismissModalFlow,
  } = useAuthStore();
  const styles = useDynamicStyles(createStyles);

  const { isVisible, isDismissible } = modalFlow;

  // Auto-complete when entire flow is done
  useEffect(() => {
    if (
      isVisible &&
      isAuthenticated &&
      hasCheckedAuth &&
      hasCheckedOnboarding &&
      isOnboarded
    ) {
      completeModalFlow();
    }
  }, [
    isVisible,
    isAuthenticated,
    hasCheckedAuth,
    hasCheckedOnboarding,
    isOnboarded,
    completeModalFlow,
  ]);

  const handleHide = () => {
    if (isDismissible) dismissModalFlow();
  };

  const loadingContent = (
    <>
      <Header
        headerTitle={
          <View style={styles.headerLogoContainer}>
            <HeaderTitle logo={LogoIcon} />
          </View>
        }
        showShadow
      />
      <Loader />
    </>
  );

  return (
    <Modal
      visible={isVisible}
      hide={handleHide}
      fadeIn
      fadeInDuration={500}
      contentStyle={styles.modalContent}
      modalStyle={styles.modal}
      showCloseButton={false}
    >
      {!isAuthenticated ? (
        <AuthModalContent />
      ) : !hasCheckedOnboarding ? (
        loadingContent
      ) : !isOnboarded ? (
        <OnboardingModalContent />
      ) : (
        loadingContent
      )}
    </Modal>
  );
}

const createStyles = () =>
  StyleSheet.create({
    modal: {
      paddingTop: 0,
    },
    modalContent: {
      alignItems: 'stretch',
      padding: 0,
    },
    headerLogoContainer: {
      width: '100%',
      height: '100%',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: 40,
      minWidth: 100,
    },
  });
